// extracted by mini-css-extract-plugin
export default {"tabHeader":"tabs_tabHeader__4fux6","tabButton":"tabs_tabButton__JtLJZ","tabButtonActive":"tabs_tabButtonActive__s2qCE"};